export const name = "LOG10";
export const summary = `Computes the natural logarithm of \`X\` to base 10.`;
export const reference = `
## LOG10

Computes the natural logarithm of \`X\` to base 10.

\`\`\`
LOG10(X)
\`\`\`

### Description

Similar to \`LOG\`, but computes logarithm to base 10.

| X | LOG10(X) |
| --- | --- |
| 100.0 | 2.0 |
| \`-inf\` | \`NaN\` |
| \`+inf\` | \`+inf\` |
| X \\<= 0 | Error |


### Return Data Type

| INPUT | \`INT64\` | \`NUMERIC\` | \`BIGNUMERIC\` | \`FLOAT64\` |
| --- | --- | --- | --- | --- |
| OUTPUT | \`FLOAT64\` | \`NUMERIC\` | \`BIGNUMERIC\` | \`FLOAT64\` |


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
